import { getContext, setContext } from 'svelte';

export type LocalizationContext = {
  language: string;
  countryCode: string;
  currencyCode: string;
};

const localizationContextKey = Symbol('athena-i18n');

export const getLocalizationContext = () => getContext<LocalizationContext>(localizationContextKey);
export const setLocalizationContext = (localizationContext: LocalizationContext) =>
  setContext<LocalizationContext>(localizationContextKey, localizationContext);
